import * as React from "react";
import { connect } from "react-redux";

import { Select, Stack, Text, TextInput } from "@mantine/core";
import { IState } from "../../../data/reducers/state";
import { IAssociation } from "../../../types/association/Association";
import { CenteredLoader } from "../../common/loader";

const associationNameRenderer = (association) =>
  association?.name || "";

interface IAssociationSelectorProps {
  associations?: IAssociation[];
  onChange: (association: IAssociation) => void;
  value?: string | null;
  disabled?: boolean | null;
  showLabel?: boolean;

  useAdminAssociations?: boolean;
}

const AssociationSelector: React.FunctionComponent<IAssociationSelectorProps> = (props) => {

  const { associations, value, showLabel, disabled, onChange } = props;
  if (!associations) return <CenteredLoader />;

  const ascns = associations || [];
  if (!value && ascns.length === 1) onChange(ascns[0]);

  return (
    <Stack gap="sm">
      {showLabel && <Text size="sm" fw={500}>Association</Text>}
      <Select
        id="association-selector"
        placeholder="Select an association"
        onChange={(selectedValue) => {
          if (selectedValue) {
            onChange(
              associations.filter((a) => a._id === selectedValue)[0],
            )
          }
        }}
        value={value || ""}
        disabled={disabled || associations.length <= 1}
        data={[
          ...(!value ? [{ value: "", label: "Select an association" }] : []),
          ...associations.map((val) => ({
            value: val._id,
            label: val ? val.name || "" : ""
          }))
        ]}
      />
    </Stack>
  );
}

function mapStateToProps(state: IState, props: IAssociationSelectorProps) {
  if (!props.useAdminAssociations || props.associations) return {};

  return {
    associations: state.associations.admin.map(
      (a) => state.associations.map[a],
    ),
  };
}

export default connect(mapStateToProps)(AssociationSelector);
